import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.scss';

const container = document.getElementById('root')!;

// MUI, React Query and the Bootstrap JS bundle are only needed by the legacy
// design; they live in src/LegacyApp.tsx and load on demand.
const app = (
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

// react-snap pre-renders static HTML at build time; hydrate it when present,
// otherwise mount fresh (normal dev / non-prerendered loads).
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
